import React from 'react';

interface SubmitButtonProps {
  isLoading: boolean;
  label?: string;
}

export function SubmitButton({ isLoading, label = 'Simular' }: SubmitButtonProps) {
  return (
    <button type="submit" className="btn btn-primary" disabled={isLoading}>
      {isLoading && (
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
      )}
      {isLoading ? 'Procesando…' : label}
    </button>
  );
}
